module.exports = __webpack_public_path__ + "img/7.0f138362.jpg";